<template>
  <div class="list-con">
    <div class="list-title">消息中心</div>

    <ul class="tabs-list">
      <li :class="{'active':isActive}" @click="checkType">审批中心</li>
      <li :class="{'active':!isActive}" @click="checkType">通知</li>
    </ul>

    <keep-alive>
      <component :is="currentComponent" :key="currentComponent" />
    </keep-alive>

  </div>

</template>

<script>
import ApprovalTable from './component/approvalTable.vue'
import NoticeTable from './component/informTable.vue'
export default {
  components: {
    ApprovalTable,
    NoticeTable
  },
  data() {
    return {
      isActive: true,
      currentComponent: 'ApprovalTable'
    }
  },
  methods: {
    checkType() {
      this.isActive = !this.isActive
      this.currentComponent = this.isActive ? 'ApprovalTable' : 'NoticeTable'
    }
  }
}
</script>

<style lang="less" scoped>
.message-center {
  width: 1084px;
  margin: 0 auto;
  .title {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 0.5px solid #e2e5f0;
    span {
      color: #000000;
      font-size: 16px;
      font-weight: 700;
      margin-left: 8px;
    }
  }
  .tabs {
    ::v-deep.el-tabs__nav-wrap::after {
      height: 0;
    }
    .item {
      ::v-deep.el-badge__content.is-fixed {
        top: 8px;
        right: 6px;
      }
    }
    ::v-deep.el-table__body {
      border-spacing: 0px 4px !important;
    }
    .button {
      margin: 10px 0 25px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        width: 122px;
        height: 38px;
        margin-right: 16px;
      }
      ::v-deep.el-input--prefix .el-input__inner {
        padding-left: 50px;
        background: #f9fafb;
        border: 1px solid rgba(0, 38, 116, 0.1);
        border-radius: 5px;
      }
    }
  }
}
</style>
